import { render, staticRenderFns } from "./DataSourceModal.vue?vue&type=template&id=40a48522&"
import script from "./DataSourceModal.vue?vue&type=script&lang=js&"
export * from "./DataSourceModal.vue?vue&type=script&lang=js&"
import style0 from "./DataSourceModal.vue?vue&type=style&index=0&id=40a48522&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports